module.exports = __webpack_public_path__ + "static/media/IMG_0966.75613903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/IMG_0966.jpg
// module id = 373
// module chunks = 0